import React, { useState, useEffect, useContext } from 'react';
import { makeStyles } from '@material-ui/styles';
import {
  List,
  ListItem,
  ListItemText,
  IconButton,
  Divider,
  Collapse
} from '@material-ui/core';
import _ from 'lodash';
import { useSelector, useDispatch } from 'react-redux';


import AddIcon from '@material-ui/icons/AddCircleOutlineOutlined';
import RemoveIcon from '@material-ui/icons/RemoveCircleOutlineOutlined';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';

import api from '../../../../common/apiService';

import OrderContext from '../../../../context/orderContext'
import withAlert from "../../../../hoc/withAlert";
import Eating from '../Eating'
import {
  getEatingByNameSelector
} from '../../../../store/eating';



const useStyles = makeStyles(theme => ({
  nestedHead: {
    paddingLeft: theme.spacing(4),
  },
  nested: {
    paddingLeft: theme.spacing(2),
  },
  weekend: {
    backgroundColor: '#e0f2f1'
  },
  divider: {
    marginBottom: theme.spacing(4),
  }
}));

const Day = props => {
  const { day, sessionId, onCheckedOne,setSnackMessage, setSnackType, setOpenSnack } = props;
  
  const orderContext = useContext(OrderContext);

  // console.log('orderContext', orderContext.actionType, orderContext.ticketId);

  const { date, weekend, meals } = day
  const classes = useStyles();
  // console.log('Day', date, props.checked)

  useEffect(() => {
    // console.log('Day useEffect', date, weekend, props.checked)
    // setOpen(props.session.open);
    setChecked(props.checked)
  }, [props.checked]);


  const [checked, setChecked] = useState(
    // []
    // _.reduce(meals , function(obj, m) {
    //   obj[m.id] = false
    //   return obj;
    //  }, {})
    props.checked
  )

  const [allChecked, setAllChecked] = React.useState(true)

  const handleChange = id => event => {
    // const checkedNew = { ...checked, [id]: !checked[id] }
    const checkedNew = { ...checked, [id]: event.target.value }
    setChecked(checkedNew);
    onCheckedOne({ [date]: checkedNew })
  };


  const handleAdd =  id => async event => {
    // const checkedNew = { ...checked, [id]: !checked[id] }
    if (orderContext.actionType === 'edit') {
      // console.log('handleAdd', { [date]: { [id]: checked[id] } });
      try {
        const res = await api.changeCoupon(orderContext.ticketId, id, props.sessionId, date.split('.').join(""), 'add') ;
        // console.log('handleCreateTicket res',res)
        if (res.status === 200) {
          const checkedNew = { ...checked, [id]: ++checked[id] }
          setChecked(checkedNew);
          onCheckedOne({ [date]: checkedNew })

          setSnackMessage('Изменения сохранены')
          setSnackType('success')
          setOpenSnack(true)
  
        }
        else {
          setSnackMessage('Ошибка. Изменения не сохранены')
          setSnackType('error')
          setOpenSnack(true)
          // setLoading(false)
        }
      }
      catch (error) {
        console.log('error.response',error);
        setSnackMessage(`Ошибка: ${error.response ? error.response.data.message : error}`)
        setSnackType('error')
        setOpenSnack(true)
        // setLoading(false)
      }

      // console.log('res.status',res.status);
  
    }
    else {
      const checkedNew = { ...checked, [id]: ++checked[id] }
      setChecked(checkedNew);
      onCheckedOne({ [date]: checkedNew })
    }

  };


  const handleMinus = id => async event => {
    // const checkedNew = { ...checked, [id]: !checked[id] }
    if (checked[id] > 0) {
    //   console.log('handleMinus', { [date]: { [id]: checked[id] } });
    // }

    if (orderContext.actionType === 'edit') {
      // console.log('handleAdd', { [date]: { [id]: checked[id] } });

      try {
        const res = await api.changeCoupon(orderContext.ticketId, id, props.sessionId, date.split('.').join(""), 'delete') ;
        // console.log('handleCreateTicket res',res)
        if (res.status === 200) {
          const checkedNew = { ...checked, [id]: checked[id] > 0 ? --checked[id] : 0 }
          setChecked(checkedNew);
          onCheckedOne({ [date]: checkedNew })
    
          setSnackMessage('Изменения сохранены')
          setSnackType('success')
          setOpenSnack(true)
  
        }
        else {
          setSnackMessage('Ошибка. Изменения не сохранены')
          setSnackType('error')
          setOpenSnack(true)
          // setLoading(false)
        }
      }
      catch (error) {
        console.log('error.response',error);
        setSnackMessage(`Ошибка: ${error.response ? error.response.data.message : error}`)
        setSnackType('error')
        setOpenSnack(true)
        // setLoading(false)
      }

      // console.log('res.status',res.status);
  
    }
    else {
      const checkedNew = { ...checked, [id]: checked[id] > 0 ? --checked[id] : 0 }
      setChecked(checkedNew);
      onCheckedOne({ [date]: checkedNew })
    }
  }

  };

  const handleAddAll = () => {
    // console.log('handleChangeAll')
    const checkedNew = _.reduce({ ...checked }, function (obj, value, index) {
      obj[index] = ++value
      return obj;
    }, {})

    setChecked(checkedNew)
    setAllChecked(!allChecked)
    onCheckedOne({ [date]: checkedNew })

  };


  const handleMinusAll = () => {
    // console.log('handleChangeAll')
    const checkedNew = _.reduce({ ...checked }, function (obj, value, index) {
      obj[index] = value > 0 ? --value : 0
      return obj;
    }, {})
    setChecked(checkedNew)
    setAllChecked(!allChecked)
    onCheckedOne({ [date]: checkedNew })

  };

  // Состояние открыт закырт
  const [open, setOpen] = useState(false);
  //  Обработчик свертывания развертывания
  const handleClick = () => {
    setOpen(!open);
  };


  //   const handleChangeAll = () => {
  //     // console.log('handleChangeAll')
  //     const checkedNew =  _.reduce(meals , function(obj, m) {
  //       obj[m.id] = allChecked
  //       return obj;
  //      }, {})
  //     setChecked(checkedNew)
  //     setAllChecked(!allChecked)
  //     onCheckedOne({[date]: checkedNew})

  //  };

  return (

    <React.Fragment>

      <ListItem  button onClick={handleClick}
        // className={classes.nestedHead}
        // button 
        // onClick={handleChangeAll}
        className={weekend ? classes.weekend : ''}
        // style={{marginTop:10}}
      >
        {/* <ListItemText primary={format(date,'dd.MM.yyyy')} /> */}
        <React.Fragment>
          {open ? <ExpandLess /> : <ExpandMore />}
          <ListItemText primary={date} />
          {/* <IconButton aria-label="add" onClick={handleAddAll} disabled={orderContext.actionType === 'edit'}>
            <AddIcon fontSize="small" />
          </IconButton>
          <IconButton aria-label="add" onClick={handleMinusAll} disabled={orderContext.actionType === 'edit'}>
            <RemoveIcon fontSize="small" />
          </IconButton> */}
        </React.Fragment>
      </ListItem >
      <Collapse in={open} timeout="auto" unmountOnExit className={classes.nested} style={{marginTop:10}}>
      <Eating name={'Завтрак'} date={date} meetingId={sessionId} eating={useSelector(getEatingByNameSelector('Завтрак'))}/>
      <Eating name={'Обед'} date={date} meetingId={sessionId} eating={useSelector(getEatingByNameSelector('Обед'))}/>
      <Eating name={'Ужин'} date={date} meetingId={sessionId} eating={useSelector(getEatingByNameSelector('Ужин'))}/>
      <div className={classes.divider}/>
      </Collapse>

      {/* <List component="div" disablePadding dense={false}
      //  className={weekend?classes.weekend:''}
      >

        {
          meals.map((m, index) => {
            const labelId = `checkbox-list-label-${m.id}`;
            // console.log(m.id)
            return (
              <ListItem key={m.id} role={undefined} dense>

                <ListItemIcon>
                  <React.Fragment>


                    <IconButton aria-label="minus" onClick={handleMinus(m.id)}>
                      <RemoveIcon fontSize="small" />
                    </IconButton>

                    <TextField
                      fullWidth
                      // label="Кол"
                      value={checked[m.id]}
                      // value={values.amount}
                      onChange={handleChange(m.id)}
                      margin="dense"
                      variant="outlined"
                      style={{ width: 50 }}
                    // disabled={!saveState}
                    />
                    <IconButton aria-label="add" onClick={handleAdd(m.id)}>
                      <AddIcon fontSize="small" />
                    </IconButton>

                  </React.Fragment>
                </ListItemIcon>

                <ListItemText id={labelId} primary={m.name} />
              </ListItem>
            )
          }
          )}

      </List>
    */}
    </React.Fragment>


  );
};


export default withAlert(Day);
